import { Box, Flex, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { ScreenContext, useApp } from '@hb/react'
import { isDev } from '@hb/shared'
import { useCallback, useContext, useMemo, useState } from 'react'
import { PregnancyChartingView } from '../../../../../charting/Pregnancy/PregnancyChartingView'
import { useProfile } from '../../../../../contexts/user/ProfileContext'
import { PatientPlansView, PregnancyPlansView } from '../../../../Assessments/InsurancePlansView'
import { AssessmentsSummary, AssessmentSummary } from '../../Assessments/AssessmentSummary'
import { AssessmentAuthorizationsTab } from '../../Authorizations/AssessmentAuthorizations'
import { AssessmentClaims } from '../../Claims/AssessmentClaims'
import { ProfileConsentForms } from '../../ConsentForms'
import { AssessmentAndPatientFiles } from '../../Files/AssessmentFiles'
import { PatientFiles } from '../../Files/PatientFiles'
import { GynProfileView } from '../../Gyn/GynProfileView'
import { ProfileLabsView } from '../../Labs/LabsView'
import { AssessmentLog } from '../../Log/AssessmentLog'
import { Resizable } from '../../Log/Resizable'
import { PatientSummary } from '../../Patient/PatientSummary'
import { AssessmentPaymentsTab } from '../../Payments/AssessmentPayments'
import { ProfileHeader } from './ProfileHeader'

const ProfileTabsPanel = ({ width, height }: { width: number; height: number }) => {
  const { appName } = useApp()
  const { assessmentId, userId } = useProfile()
  // const numAssessments = Object.keys(assessments ?? {}).length
  const mobileLayout = useMemo(() => width < 769, [width])
  return (
    <TabPanels
      overflowY="auto"
      style={{ width: 'auto' }}
      bg="#f3f3f3"
      height={`${height}px`}
      // height={contentHeight}
    >
      <TabPanel bg="gray.100" minH="100%" px={0}>
        <PatientSummary />
      </TabPanel>
      {/* {numAssessments ? ( */}
      <TabPanel bg="gray.100" minH="100%" p={0}>
        {assessmentId ? <AssessmentSummary width={width} /> : <AssessmentsSummary />}
      </TabPanel>
      {/* ) : null} */}
      {assessmentId ? null : (
        <TabPanel bg="gray.100" h="100%" w="100%" p={0}>
          <GynProfileView />
        </TabPanel>
      )}
      <TabPanel p={mobileLayout ? 0 : 3}>
        <Box w="100%" bg="white" boxShadow="1px 1px 4px #00000055" borderRadius={6}>
          {assessmentId ? <PregnancyPlansView /> : <PatientPlansView />}
        </Box>
      </TabPanel>
      {assessmentId && appName === 'app' ? (
        <TabPanel py={mobileLayout ? 1 : 0} px={mobileLayout ? 1 : 2}>
          <AssessmentPaymentsTab />
        </TabPanel>
      ) : null}
      {appName === 'app' && assessmentId ? (
        <TabPanel p={0}>
          <AssessmentAuthorizationsTab />
        </TabPanel>
      ) : null}
      {appName === 'app' && assessmentId ? (
        <TabPanel p={0}>
          <AssessmentClaims />
        </TabPanel>
      ) : null}
      {assessmentId && isDev ? (
        <TabPanel h="100%" p={0}>
          <PregnancyChartingView />
        </TabPanel>
      ) : null}
      {isDev ? (
        <TabPanel h="100%" p={0}>
          <ProfileLabsView />
        </TabPanel>
      ) : null}
      {/* {appName === 'app' ? ( */}
      <TabPanel>
        {assessmentId ? <AssessmentAndPatientFiles width={width} /> : <PatientFiles />}
      </TabPanel>
      {/* <TabPanel h="100%" p={0}>
        {userId ? (
          <ProfileVisits onlyStandaloneVisits={false} assessmentId={null} />
        ) : (
          <LoadingOverlay text="Loading visits..." />
        )}
      </TabPanel> */}
      <TabPanel h="100%" p={0}>
        <ProfileConsentForms />
      </TabPanel>
      {/* ) : null} */}
    </TabPanels>
  )
}

export const ProfileBody = ({ height, width }: { height: number; width: number }) => {
  const { goTo, tabs, tab, assessmentId } = useProfile()
  const { appName } = useApp()
  const index = useMemo(() => {
    const match = tabs.findIndex(t => t.path === tab?.path)
    return match >= 0 ? match : 0
  }, [tabs, tab])

  const { isMobile } = useContext(ScreenContext)
  const [headerHeight, setHeaderHeight] = useState(0)
  const contentHeight = useMemo(() => height - headerHeight, [height, headerHeight])

  const goToTab = useCallback(
    (i: number) => {
      const tab = tabs[i]
      if (!tab) return
      goTo({
        tab: tab.path,
        entity: assessmentId ? { id: assessmentId, type: 'pregnancy' } : null,
      })
    },
    [goTo, tabs, assessmentId],
  )

  return (
    <Flex height={height} w="100%" overflow="hidden" flexFlow="column">
      <Tabs
        index={index}
        onChange={i => goToTab(i)}
        style={{
          height: `${height}px`,
          background: 'rgba(255,255,255,0.9)',
        }}
        isLazy>
        <ProfileHeader
          width={width}
          onResize={size => {
            setHeaderHeight(size.height)
          }}
        />
        {isMobile || appName === 'providers-app' ? (
          <ProfileTabsPanel height={contentHeight} width={width} />
        ) : (
          <Resizable
            width={width}
            hideRight={!assessmentId}
            height={contentHeight}
            localStorageId="user-profile-resize"
            leftChild={leftWidth => <ProfileTabsPanel height={contentHeight} width={leftWidth} />}
            rightChild={() => <AssessmentLog maxHeight={contentHeight} />}
          />
        )}
      </Tabs>
    </Flex>
  )
}
